import { FC } from 'react';
import { useQueryParams } from 'hooks/useQueryParams';

import ExclusionConfirmComponent from '../account/ExclusionConfirmComponent';
import { MemberProgram } from '../constants';

const NpExclusionConfirmComponent: FC = () => {
  const { getParam } = useQueryParams();
  const memberId = getParam('memberId');
  return (
    <ExclusionConfirmComponent
      redirectUrl={`/np/members/${memberId}/exclusions`}
      program={MemberProgram.NP}
    />
  );
};

export default NpExclusionConfirmComponent;
